import { Page, Text, View, Document, StyleSheet ,Font ,Image} from '@react-pdf/renderer';
import React from 'react'
import LatoRegular from '../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
Font.register({
    family: 'Lato',
    fonts: [
      { src: LatoRegular, fontWeight: 400 },
      { src: LatoBold , fontWeight: 700 }
    ]
});
  
const styles = StyleSheet.create({
    footer: {
        position: "fixed",
        bottom: "0px",
        borderTop: "1px solid #426B88",
        display: "flex",
        flexDirection: "row",
        width: "570px",
        gap: "30px"
    },
    footertitle: {
        fontFamily: "Lato",
        fontWeight: 700,
        fontSize: "10px",
        lineHeight: "18px",
        color: "#76A3BE",
        textTransform: "uppercase",
        marginTop: "10px"
    },
    description: {
        color: "#76A3BE",
        fontFamily: "Lato",
        fontWeight: 400,
        fontSize: "8px",
        lineHeight: "18px",
        width: "496px"

    },
    pagenumber: {
        fontFamily: "Lato",
        fontWeight: 700,
        fontSize: "10px",
        lineHeight: "18px",
        color: "#76A3BE",
        marginTop: "10px"
    }
});


const Footer = () => (
   <View style={styles.footer}>
                   <View>
                       <Text style={styles.footertitle}>SELF Report</Text>
                       <Text style={styles.description}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
                   </View>
                   <View style={styles.pagenumber}>
                       <Text>PAGE</Text>
                   </View>
   
               </View>
);



export default Footer;
